import DrawerResizerController from '@app/application/behaviors/drawers/drawer-resizer-controller'
import { rightDrawerLayout } from '@app/application/behaviors/drawers/right-drawer-layout'

export default class extends DrawerResizerController {
  protected readonly layout = rightDrawerLayout
  protected readonly resizingClass = 'right-drawer-resizing'
  protected readonly widenKey = 'ArrowLeft'
}
